<span axChip class="chip" [ngClass]="{removable: _removable}">
  <ax-icon class="icon" *ngIf="icon" [name]="icon"></ax-icon>
  <ng-content></ng-content>
  <button class="remove-button" *ngIf="_removable" axButton icon-button (click)="removed.emit()">
    <ax-icon class="icon remove-icon" name="close"></ax-icon>
  </button>
</span>
